import React from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css'; // Default calendar styles

const BookingCalendar = ({ selectedDate, onDateChange }) => {
    return (
        <div className="my-4">
            <h3 className="text-xl font-semibold mb-2">Select a Date</h3>
            <Calendar
                onChange={onDateChange}
                value={selectedDate}
                minDate={new Date()} // Cannot select past dates
                className="react-calendar-custom" // Custom class for Tailwind styling
            />
        </div>
    );
};

export default BookingCalendar;